const normalizeToTriggerSettings = data => {
  return data.triggerResponse.body.sort((a, b) =>
    a.priority > b.priority ? 1 : -1
  );
};

export default normalizeToTriggerSettings;
